import * as z from 'zod';
import { Currency } from '../../../currency/currency.mjs';
import { currencySchema } from '../../../utils.mjs';
import { LineItemGroup } from './line-item-group.mjs';

var CurrentAssets;
(function (CurrentAssets) {
    CurrentAssets.schema = z.object({
        cash: LineItemGroup.schema,
        restrictedCash: LineItemGroup.schema,
        marketableSecurities: LineItemGroup.schema,
        accountsReceivable: LineItemGroup.schema,
        contractAssets: LineItemGroup.schema,
        retainage: LineItemGroup.schema,
        underbillings: LineItemGroup.schema,
        inventory: LineItemGroup.schema,
        prepaids: LineItemGroup.schema,
        currentShareholderEmplReceivables: LineItemGroup.schema,
        relatedPartyReceivables: LineItemGroup.schema,
        otherCurrentAssets: LineItemGroup.schema,
        total: currencySchema,
    });
})(CurrentAssets || (CurrentAssets = {}));
var FixedAssets;
(function (FixedAssets) {
    FixedAssets.schema = z.object({
        generalFixedAssets: LineItemGroup.schema,
        realEstate: LineItemGroup.schema,
        equipment: LineItemGroup.schema,
        officeEquipmentFurnitureFixtures: LineItemGroup.schema,
        software: LineItemGroup.schema,
        accumulatedDepreciation: LineItemGroup.schema,
        otherFixedAssets: LineItemGroup.schema,
        total: currencySchema,
    });
})(FixedAssets || (FixedAssets = {}));
var NonCurrentAssets;
(function (NonCurrentAssets) {
    NonCurrentAssets.schema = z.object({
        otherReceivables: LineItemGroup.schema,
        relatedPartyReceivables: LineItemGroup.schema,
        nonCurrentShareholderEmplReceivables: LineItemGroup.schema,
        deposits: LineItemGroup.schema,
        rouAssets: LineItemGroup.schema,
        goodwill: LineItemGroup.schema,
        intangibles: LineItemGroup.schema,
        investment: LineItemGroup.schema,
        otherNonCurrentAssets: LineItemGroup.schema,
        currentAssetsDropped: LineItemGroup.schema,
        total: currencySchema,
    });
})(NonCurrentAssets || (NonCurrentAssets = {}));
var CurrentLiabilities;
(function (CurrentLiabilities) {
    CurrentLiabilities.schema = z.object({
        accountsPayable: LineItemGroup.schema,
        contractLiabilities: LineItemGroup.schema,
        retainagePayable: LineItemGroup.schema,
        overbillings: LineItemGroup.schema,
        customerDeposits: LineItemGroup.schema,
        accruedExpenses: LineItemGroup.schema,
        accruedLossesOnContracts: LineItemGroup.schema,
        creditCardsBalance: LineItemGroup.schema,
        cashOverdraft: LineItemGroup.schema,
        blocBalance: LineItemGroup.schema,
        currentPortionOfLtd: LineItemGroup.schema,
        otherNotesPayable: LineItemGroup.schema,
        taxesPayable: LineItemGroup.schema,
        taxesDeferred: LineItemGroup.schema,
        relatedPartyPayable: LineItemGroup.schema,
        shareholderEmplPayable: LineItemGroup.schema,
        currentPortionOfRouLiabilities: LineItemGroup.schema,
        otherCurrentLiabilities: LineItemGroup.schema,
        total: currencySchema,
    });
})(CurrentLiabilities || (CurrentLiabilities = {}));
var NonCurrentLiabilities;
(function (NonCurrentLiabilities) {
    NonCurrentLiabilities.schema = z.object({
        ltdBankTermLoan: LineItemGroup.schema,
        ltdRealEstate: LineItemGroup.schema,
        ltdEquipment: LineItemGroup.schema,
        ltdOther: LineItemGroup.schema,
        ltdShareholder: LineItemGroup.schema,
        ltdRelatedParty: LineItemGroup.schema,
        taxesDeferred: LineItemGroup.schema,
        ltPortionOfRouLiabilities: LineItemGroup.schema,
        ltPortionOfAccruedLossesOnContracts: LineItemGroup.schema,
        otherLtLiabilities: LineItemGroup.schema,
        currentLiabilitiesDropped: LineItemGroup.schema.default(() => ({
            total: Currency.ZERO,
            lineItems: [],
        })),
        total: currencySchema,
    });
})(NonCurrentLiabilities || (NonCurrentLiabilities = {}));
var Equity;
(function (Equity) {
    Equity.schema = z.object({
        stocksIssuedAndOutstanding: LineItemGroup.schema,
        treasuryStock: LineItemGroup.schema,
        paidInCapital: LineItemGroup.schema,
        retainedEarnings: LineItemGroup.schema,
        currentYearEarnings: LineItemGroup.schema,
        distributions: LineItemGroup.schema,
        otherEquity: LineItemGroup.schema,
        equityAdjustments: LineItemGroup.schema.default(() => ({
            total: Currency.ZERO,
            lineItems: [],
        })),
        total: currencySchema,
    });
})(Equity || (Equity = {}));
var Assets;
(function (Assets) {
    Assets.schema = z.object({
        current: CurrentAssets.schema,
        fixed: FixedAssets.schema,
        nonCurrent: NonCurrentAssets.schema,
        total: currencySchema,
    });
})(Assets || (Assets = {}));
var Liabilities;
(function (Liabilities) {
    Liabilities.schema = z.object({
        current: CurrentLiabilities.schema,
        nonCurrent: NonCurrentLiabilities.schema,
        total: currencySchema,
    });
})(Liabilities || (Liabilities = {}));
var BalanceSheetData;
(function (BalanceSheetData) {
    BalanceSheetData.schema = z.object({
        assets: Assets.schema,
        liabilities: Liabilities.schema,
        equity: Equity.schema,
    });
})(BalanceSheetData || (BalanceSheetData = {}));

export { Assets, BalanceSheetData, CurrentAssets, CurrentLiabilities, Equity, FixedAssets, Liabilities, NonCurrentAssets, NonCurrentLiabilities };
